import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "@tsp-core/store/utils";

import { CurrencyId } from "@tsp-domains/money/enums";
import { PartyUuid } from "@tsp-domains/parties/types";
import { SystemTypeId } from "@tsp-domains/system-types/enums";

import { ContractorAccountRecord, ContractorAccountUuid, ContractorsAccountsList } from "../types";

export type GetContractorsAccountsResponseData = {
  _embedded: {
    account: Array<{
      uuid: ContractorAccountUuid;
      ownerUuid: PartyUuid;
      currencyId: CurrencyId;
      systemType: SystemTypeId;
    }>;
  };
};

export const contractorsAccountsApi = createApi({
  reducerPath: "@contractors-accounts/api",
  baseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  refetchOnMountOrArgChange: false,
  keepUnusedDataFor: 0,
  tagTypes: ["ContractorsAccountsList"],
  endpoints: (builder) => ({
    getContractorsAccounts: builder.query<ContractorsAccountsList, void, GetContractorsAccountsResponseData>({
      query: () => {
        return {
          url: "/get-contractors-accounts",
          method: "GET",
        };
      },
      transformResponse: (response: GetContractorsAccountsResponseData): ContractorsAccountsList => {
        return response._embedded.account.map(
          (account): ContractorAccountRecord => ({
            uuid: account.uuid,
            ownerUuid: account.ownerUuid,
            currencyId: account.currencyId,
            systemTypeId: account.systemType,
          }),
        );
      },
    }),
  }),
});
